// extracted by mini-css-extract-plugin
export var clearIcon = "styles-module__clearIcon___eqSXg";
export var container = "styles-module__container___Bddzs";
export var iconAndTitle = "styles-module__iconAndTitle___MRgAT";
export var title = "styles-module__title___ek1n9";